import { MuiAlert } from "./MuiAlert";
import { MuiAppBar } from "./MuiAppBar";
import { MuiAvatar } from "./MuiAvatar";
import { MuiButton } from "./MuiButton";
import { MuiButtonGroup } from "./MuiButtonGroup";
import { MuiCard } from "./MuiCard";
import { MuiCardActions } from "./MuiCardActions";
import { MuiCardContent } from "./MuiCardContent";
import { MuiCardHeader } from "./MuiCardHeader";
import { MuiCheckbox } from "./MuiCheckbox";
import { MuiChip } from "./MuiChip";
import { MuiInputBase } from "./MuiInputBase";
import { MuiLink } from "./MuiLink";
import { MuiListItemIcon } from "./MuiListItemIcon";
import { MuiListSubheader } from "./MuiListSubheader";
import { MuiMenu } from "./MuiMenu";
import { MuiOutlinedInput } from "./MuiOutlinedInput";
import { MuiPaper } from "./MuiPaper";
import { MuiTypography } from "./MuiTypography";
import { MuiDialogActions } from "./MuiDialogActions";
export var components = {
    MuiAppBar: MuiAppBar,
    MuiAvatar: MuiAvatar,
    MuiButton: MuiButton,
    MuiButtonGroup: MuiButtonGroup,
    MuiLink: MuiLink,
    MuiListItemIcon: MuiListItemIcon,
    MuiListSubheader: MuiListSubheader,
    MuiMenu: MuiMenu,
    MuiPaper: MuiPaper,
    MuiInputBase: MuiInputBase,
    MuiTypography: MuiTypography,
    MuiOutlinedInput: MuiOutlinedInput,
    MuiCardActions: MuiCardActions,
    MuiCardContent: MuiCardContent,
    MuiCardHeader: MuiCardHeader,
    MuiCard: MuiCard,
    MuiChip: MuiChip,
    MuiAlert: MuiAlert,
    MuiCheckbox: MuiCheckbox,
    MuiDialogActions: MuiDialogActions,
};
